export default {
  data() {
    return {
      currentPage: 1,
      alltotal:1000,
      pageSize:15,
      value:'',//选择活动
      sort:'',//序号
      input: '',//搜索课程
      input1: '',//添加任务名称
      input2: '',//添加任务详细
      input3:'',//修改任务名称
      input4:'',//修改任务详细
      changetasksid:'',//修改任务时用的id
      activity_id:'',//活动id
      tasks_idd:'',//任务id
      visible: false,
       dialogVisible: false,
       dialogVisible1: false,
       dialogVisible2: false,
       dialogVisible3: false,
       tableData:[],//任务      
    filterarr:[],//过滤
    activity_arrs:[],
    gridData:[],//任务里的活动
    activitied:[],//选取表的活动
    activityflag:false,
      inputVisible: false,
      inputValue: ''
    }
    
  },
  methods: {
    //搜索
    confirmSearch(){
      let obj={
        token:this.$store.state.id,
        name:this.input,
        offset:0,
        length:10
      };
      this.$post('tasks/shop_search',obj).then(res=>{
        this.tableData=res.data.result.data
        
      })
    },

    //添加活动到待加入页面
    idnexer(data){
      // // console.log(data)
     let arr=this.activitied.filter((item,index)=>{
       return item.name==data;  
     })
    this.activity_id=arr[0].id
    //  // console.log(arr[0].id)
    },
     //添加活动
     pushitem(){
      // // console.log(m)
      this.objj={
        activitie_name:this.value,
        sort:this.sort,
        activitie_id:this.activity_id
      }      
        if(this.objj.activitie_name!=''&&this.objj.sort!=''){
         if(this.gridData!=''){
          for(let m of this.gridData){  
            // // console.log(m)
            if(m.activitie_name==this.objj.activitie_name){
               this.activityflag=true
            }           
          }
              if(this.activityflag){
              this.$message({
                message: `活动名称重复`,
                type: 'warning'
              });
              this.activityflag=false
              }else{
                // // console.log("进来啦")
                this.gridData.push(this.objj);
                this.value=''
                this.sort=''                
                }     
         }else{
          this.gridData.push(this.objj);
          this.value='',
          this.sort=''
         }
    
        }else{
          this.$message({
            message: `活动名称为空
                      或排序序号为空`,
            type: 'warning'
          });
        }
      
     
     
      
    //  // console.log()
    //   for(let i=0;i<this.stemdata.length;i++){
    //     let flag = true;         
    //     for(let j=0;j<this.gridData.length;j++){
    //       if(this.stemdata[i].name == this.gridData[j].activitie_name){
    //          flag = false;
    //       }
    //     }
    //     if(flag){
    //       this.stemdata[i].activitie_name=this.stemdata[i].name;
    //       this.gridData.push(this.stemdata[i])
    //     }
    //   }      
    //   //  // console.log(this.gridData)     
    //   this.dialogVisible2 = false
    },
    //数组去除重复对象元素
    // deleteRe(a, b) {
    //   var c = a.concat(b),//合并成一个数组
    //   temp = {},//用于id判断重复
    //   result = [];//最后的新数组
    //   //遍历c数组，将每个item.name在temp中是否存在值做判断，
    //   c.map((item,index)=>{
    //   if(!temp[item.id]){
    //     item.activitie_name=item.name;
    //   result.push(item);
    //   temp[item.id] = true;
    //   }
    //   })
    //   // console.log(result)
    //   },
     
    //获取任务里的活动
    peizhi(m){
      // // console.log(m)
      this.tasks_idd=m;
      // // console.log(this.tasks_idd)
      // // console.log(this.gridData.keys())
      this.$post('task_activities/search',{token:this.$store.state.id,offset:0,length:999,task_id:this.tasks_idd}).then(res=>{
          // // console.log(res.data.result.data)

          this.gridData =res.data.result.data;

            // // console.log(this.gridData)

          // this.filterarr =[...this.gridData];
          // // console.log(this.filterarr)
        })
      //   //获取活动
        this.$post('activities/search',{token:this.$store.state.id,offset:0,length:10}).then(res=>{
          this.activitied=res.data.result.data
        })
          // this.stemdata=this.aa;
      this.dialogVisible1= true; 
      
    },
    //修改任务里的活动
    pushout(){
      // // console.log(this.gridData)
        for(let m of this.gridData){
          // // console.log(m)
          this.activity={
            activity_id:m.activitie_id,
            task_id:this.tasks_idd,
            sort:m.sort,          
          }
          this.activity_arrs.push(this.activity)
          // // console.log(this.activity_arrs)
        }     
        //过滤
        // const requestArr=this.activity_arrs.filter((item,index)=>{
        //      let flag=false;
            
        //       for(var item1 of this.filterarr){
        //         if(item.activitie_name==item1.activitie_name){
        //           flag=true;
        //         }               
        //       }    
        //       return !flag;
        //   });
          // // console.log(requestArr)
        let activity_arrss=JSON.stringify(this.activity_arrs);
        // // console.log(activity_arrss)
        this.$post('task_activities/create',{token:this.$store.state.id,activity_arrs:activity_arrss,task_id:this.tasks_idd}).then(res=>{
            // // console.log(res)
            this.activity_arrs=[];
            // // console.log(this.activity_arrs)
          })
         
      // // console.log(this.gridData)
      this.dialogVisible1 = false
    },
   
    //移除任务里的活动
    activitiesded(n){
      // // console.log(n.$index)
      this.$confirm('此操作将永久删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        // center: true
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        }); 
      this.gridData.splice(n.$index,1)
      
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'    
        // });
      });     
    },
    //删除任务
    todelete(m){
        // // console.log(m)        
        this.$confirm('此操作将永久删除该任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          // center: true
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.$post('tasks/delete',{token:this.$store.state.id,id:m}).then(res=>{  
            // // console.log(res)
            this.gettasks()         
          })   
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'    
          // });
        }); 
    },
    //获取要修改的任务
    getchangetasks(m){
      this.changetasksid = m;
      this.$post('tasks/get',{token:this.$store.state.id,id:m}).then(res=>{
        // // console.log(res.data.result)
        this.input3=res.data.result.name;
        this.input4=res.data.result.desc;
      })
      this.dialogVisible3=true;
    },
    //修改任务
    changetasks(){
      // // console.log(this.changetasksid)
      this.$post('tasks/edit',{token:this.$store.state.id,id:this.changetasksid,name:this.input3,desc:this.input4,shop_id:1}).then(res=>{  
        // // console.log(res)
        this.gettasks()         
      }) 
      this.dialogVisible3=false;  
    },
    // 查询任务
    gettasks(){
      this.$post('tasks/shop_search',{token:this.$store.state.id,offset:0,length:999}).then(res=>{
        // // console.log(res.data.result.data)
        this.tableData=res.data.result.data
        this.alltotal=this.tableData.length
      })
    },
    //分页
    handleSizeChange(val) {
      // // console.log(`每页 ${val} 条`);
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      // // console.log(`当前页: ${val}`);        
      this.currentPage = val;    //动态改变

    },
    
   //添加任务
    addtasks(){
     this.$post('tasks/create',{token:this.$store.state.id,name:this.input1,desc:this.input2,shop_id:1}).then(res=>{
            this.obj=
            { 
              name:this.input1,
              desc:this.input2
            }
            if(this.obj.name==''){
              this.$message({
                type: 'error',
                message: '请输入名称！'
              });
              return
            }
            if(this.obj.desc==''){
              this.$message({
                type: 'error',
                message: '请输入描述！'
              });
              return
            }
          this.tableData.push(this.obj);
          this.input1=''
          this.input2=''
          // this.tableData=[];
          // this.tableData=arr;
          
          this.$message({
            type: 'success',
            message: '添加成功'
          });
          this.gettasks()  
          this.dialogVisible  = false
      })
        
    },
    handleClick(row) {
      // // console.log(row);
    },
    // handleInputConfirm() {
    //   let inputValue = this.inputValue;
    //   if (inputValue) {
    //     this.stemdata.push(inputValue);
    //   }
    //   this.inputVisible = false;
    //   this.inputValue = '';
    // },
    // handleClose1(tag) {
    //   // // console.log(this.stemdata.indexOf(tag))
    //   this.stemdata.splice(this.stemdata.indexOf(tag), 1);
    // },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  },
  mounted: function () {
    this.gettasks()
  }

}